import * as angular from 'angular';

import { SelectFieldMenuItemComponent } from './select-field-menu-item.component';
import { SelectFieldComponent } from './select-field.component';

export const SelectFieldModule =
  /* prettier-ignore */
  angular
    .module('select-field', [])
    .component('selectField', SelectFieldComponent)
    .component('selectFieldMenuItem', SelectFieldMenuItemComponent)
    .name;
